module.exports = __webpack_public_path__ + "img/7.fc4bc433.svg";